module.exports = __webpack_public_path__ + "static/favicon-85a14cc7a2aa5947cc1099c9611bdc3a.ico";